// import "react-app-polyfill/ie9"; // For IE 9-11 support
// import "react-app-polyfill/stable";
// // import 'react-app-polyfill/ie11'; // For IE 11 support
// import "./polyfill";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App2 from "./App2";
import store from "./store";
import { Provider } from "mobx-react";
import setAuthToken from "./utils/setAuthToken";
import jwt_decode from "jwt-decode";
import * as serviceWorker from "./serviceWorker";
import SessionTimeout from "./helpers/SessionTimeout.helper";
const rootStore = new store();

if (sessionStorage.jwtToken && sessionStorage.preferences) {
  //set Auth Token auth
  SessionTimeout();
  try {
    setAuthToken(sessionStorage.jwtToken);
    // Decode token and get user info and expiration

    const decoded = jwt_decode(sessionStorage.jwtToken);
    const preferences = jwt_decode(sessionStorage.preferences);

    // Set user and isAuthenticated

    // store.dispatch(setCurrentUser(decoded));
    rootStore.AuthStore.setUser(decoded, preferences);
    if (localStorage.getItem("specialtyFlag")) {
      rootStore.GuaranteeStore.setFlag(true);
    }
    localStorage.removeItem("d_start_date");
    localStorage.removeItem("d_end_date");

    //Check for Expired token

    const currentTime = Date.now() / 1000;

    if (decoded.exp < currentTime) {
      sessionStorage.removeItem("jwtToken");
      sessionStorage.removeItem("preferences");
      //TODO: Clear Current Profile
      window.location.href = "/";
      //TODO: Redirect to login
    }
  } catch (err) {
    sessionStorage.removeItem("jwtToken");
    sessionStorage.removeItem("preferences");
    window.localStorage.clear();
    //TODO: Clear Current Profile
    window.location.href = "/";
    //TODO: Redirect to login
  }
} else {
  window.localStorage.clear();
}

const Root = (
  <Provider
    AuthStore={rootStore.AuthStore}
    DashboardStore={rootStore.DashboardStore}
    EntityStore={rootStore.EntityStore}
    UserStore={rootStore.UserStore}
    GuaranteeStore={rootStore.GuaranteeStore}
    DispensingStore={rootStore.DispensingStore}
    ParticipantStore={rootStore.ParticipantStore}
    PhysicianStore={rootStore.PhysicianStore}
    ClaimsStore={rootStore.ClaimsStore}
    PharmaciesStore={rootStore.PharmaciesStore}
    DateRangeStore={rootStore.DateRangeStore}
    GroupStore={rootStore.GroupStore}
    PgxStore={rootStore.PgxStore}
    RxTourismStore={rootStore.RxTourismStore}
    PcmSavingsStore={rootStore.PcmSavingsStore}
    OpioidUsageStore={rootStore.OpioidUsageStore}
    DawReviewStore={rootStore.DawReviewStore}
    LowValueDrugsStore={rootStore.LowValueDrugsStore}
    BudgetPlanningStore={rootStore.BudgetPlanningStore}
    NdcPricingStore={rootStore.NdcPricingStore}
    NoCopayStore={rootStore.NoCopayStore}
    EligibilityStore={rootStore.EligibilityStore}
    ExecutiveSummaryStore={rootStore.ExecutiveSummaryStore}
    PerformancePackageStore={rootStore.PerformancePackageStore}
    BobSavingsStore={rootStore.BobSavingsStore}
    PharmacyRebateStore={rootStore.PharmacyRebateStore}
    PharmacyActionStore={rootStore.PharmacyActionStore}
    AdminStore={rootStore.AdminStore}
    LabelStore={rootStore.LabelStore}
    ReportStore={rootStore.ReportStore}
    AlternativeFundingStore={rootStore.AlternativeFundingStore}
    SpecialtyCarveOutStore={rootStore.SpecialtyCarveOutStore}
    RebateManagementStore={rootStore.RebateManagementStore}
    InternationalRxStore={rootStore.InternationalRxStore}
    CostPlusStore={rootStore.CostPlusStore}
    RebatesStore={rootStore.RebatesStore}
    SettingStore={rootStore.SettingStore}
    DashboardCommonsStore={rootStore.DashboardCommonsStore}
    DrugSearchStore={rootStore.DrugSearchStore}
    MarketCheckStore={rootStore.MarketCheckStore}
    ReportBookStore={rootStore.ReportBookStore}
    BenzoUsageStore={rootStore.BenzoUsageStore}
    CfoSummaryStore={rootStore.CfoSummaryStore}
    MedicalSummaryStore={rootStore.MedicalSummaryStore}
    MedicalClaimsStore={rootStore.MedicalClaimsStore}
    MedicalProvidersStore={rootStore.MedicalProvidersStore}
    MedicalPhysiciansStore={rootStore.MedicalPhysiciansStore}
    MedicalDiagnosisStore={rootStore.MedicalDiagnosisStore}
    MedicalProcedureStore={rootStore.MedicalProcedureStore}
    MedicalParticipantsStore={rootStore.MedicalParticipantsStore}
    MedicalMarketCheckStore={rootStore.MedicalMarketCheckStore}
    MedicalRecommendationStore={rootStore.MedicalRecommendationStore}
    MedicalInsightsStore={rootStore.MedicalInsightsStore}
    NdcLookUpStore={rootStore.NdcLookUpStore}
    MedicalMedicareLookupStore={rootStore.MedicalMedicareLookupStore}
    BrokerAdminStore={rootStore.BrokerAdminStore}
    BrokerIndexStore={rootStore.BrokerIndexStore}
    SavedContractStore={rootStore.SavedContractStore}
    SpecialtyPerformanceStore={rootStore.SpecialtyPerformanceStore}
    AWPValidationStore={rootStore.AWPValidationStore}
    ClinicalReviewStore={rootStore.ClinicalReviewStore}
    TemplateStore={rootStore.TemplateStore}
    DefaultSettingStore={rootStore.DefaultSettingStore}
    MarketCheckProgramStore={rootStore.MarketCheckProgramStore}
    ChronicCareManagementStore={rootStore.ChronicCareManagementStore}
    PharmacySavingsStore={rootStore.PharmacySavingsStore}
    RxValetPapStore={rootStore.RxValetPapStore}
    RxValetInternationalStore={rootStore.RxValetInternationalStore}
    InternationalTeleHealthStore={rootStore.InternationalTeleHealthStore}
  >
    <App2 />
  </Provider>
);
ReactDOM.render(Root, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
